import React, { cloneElement } from 'react';
import { Check, Shield, Download, Monitor, Lock, Clock, CreditCard, Building, Smartphone } from 'lucide-react';
interface FinalCTAProps {
  timeLeft: {
    hours: number;
    minutes: number;
    seconds: number;
  };
}
export function FinalCTA({
  timeLeft
}: FinalCTAProps) {
  const pad = (n: number) => n.toString().padStart(2, '0');
  const trustBlocks = [{
    icon: <Shield className="w-6 h-6" data-id="element-108" data-mp="m46nsf3n50n7" />,
    label: 'ACCESO INMEDIATO Y DE POR VIDA'
  }, {
    icon: <Download className="w-6 h-6" data-id="element-109" data-mp="h6n8dbv7ihto" />,
    label: 'DESCARGABLE Y CONSULTABLE'
  }, {
    icon: <Monitor className="w-6 h-6" data-id="element-110" data-mp="vtq8lqawz4kp" />,
    label: 'DESDE CUALQUIER DISPOSITIVO'
  }, {
    icon: <Lock className="w-6 h-6" data-id="element-111" data-mp="qwq1dc2bvvs0" />,
    label: 'COMPRA 100% SEGURA'
  }];
  return <section className="relative bg-cosmic overflow-hidden pt-4 md:pt-8 pb-4 md:pb-7 px-4" data-id="element-112" data-mp="14uog4ikk9u81">
      <div className="absolute -top-32 -left-32 w-[500px] h-[500px] bg-orange/20 rounded-full blur-3xl pointer-events-none" data-id="element-113" data-mp="zwv8dl3m0s5n"></div>
      <div className="absolute -bottom-32 -right-32 w-[500px] h-[500px] bg-purple-600/25 rounded-full blur-3xl pointer-events-none" data-id="element-114" data-mp="2c5y85iig49b9"></div>

      <div className="relative max-w-5xl mx-auto" data-id="element-115" data-mp="2h5kldry9xpk2">
        {/* Big intro headline */}
        <div className="text-center mb-2" data-id="element-116" data-mp="2m4xaykgj5aqc">
          <h2 className="font-display font-black text-white text-2xl md:text-5xl leading-tight mb-1" data-id="element-117" data-mp="2r278kne2osp9">
            El próximo domingo podés{' '}
            <span className="text-gold" data-id="element-118" data-mp="2v38z8ftxbwfm">seguir improvisando.</span>
          </h2>
          <h2 className="font-display font-black text-white text-2xl md:text-5xl leading-tight" data-id="element-119" data-mp="301apbkprow0l">
            O podés tener{' '}
            <span className="text-gold" data-id="element-120" data-mp="34vexg7arra39">todo resuelto desde hoy.</span>
          </h2>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-4" data-id="element-121" data-mp="39uhx1c7zco3u">
          <p className="italic text-white/70 text-[10px] md:text-sm leading-snug mb-1" data-id="element-122" data-mp="3est3dcz2gghb">
            Da igual si estás en Argentina, México, Colombia, Chile, Perú,
            Guatemala, Costa Rica, Bolivia, Ecuador o cualquier rincón del mundo
            hispanohablante.
          </p>
          <p className="text-gold font-bold text-[12px] md:text-lg whitespace-nowrap" data-id="element-123" data-mp="1eqbfpv86p4m4">
            El problema es el mismo. La solución también.
          </p>
        </div>

        {/* Countdown — highlighted */}
        <div className="flex justify-center mb-4 md:mb-6" data-id="element-124" data-mp="1np59ldu4rgvz">
          <div className="w-full max-w-[560px] bg-gradient-to-b from-danger/20 to-danger/5 border-2 border-danger/50 rounded-2xl px-3 py-3 sm:px-5 md:px-6 md:py-4 shadow-[0_0_30px_rgba(220,38,38,0.35)] text-center" data-id="element-125" data-mp="22ekyeoa3pc91">
            <p className="text-danger font-bold uppercase tracking-widest text-[11px] sm:text-[12px] md:text-base mb-1.5 whitespace-nowrap flex items-center justify-center gap-1.5" data-id="element-126" data-mp="2bfstyyl8fyzf">
              <span className="w-2 h-2 rounded-full bg-danger pulse-soft inline-block" data-id="element-127" data-mp="h18bmskdwfj7"></span>
              ⏰ El precio de lanzamiento cierra en:
            </p>
            <div className="grid grid-cols-[1fr_auto_1fr_auto_1fr] items-baseline w-full font-display font-black text-gold drop-shadow-[0_0_15px_rgba(245,166,35,0.6)]" data-id="element-128" data-mp="d1pvsb7f6un8">
              <span className="whitespace-nowrap text-[30px] sm:text-4xl md:text-5xl" data-id="element-129" data-mp="6w9tolxk9pzk">
                {pad(timeLeft.hours)}
                <small className="ml-0.5 text-[10px] sm:text-xs md:text-sm" data-id="element-130" data-mp="3pbap3se9z45u">
                  hs
                </small>
              </span>
              <span className="text-gold/70 text-xl sm:text-2xl md:text-3xl" data-id="element-131" data-mp="3fcv7cg151790">
                :
              </span>
              <span className="whitespace-nowrap text-[30px] sm:text-4xl md:text-5xl" data-id="element-132" data-mp="3kcpv4apm9gpu">
                {pad(timeLeft.minutes)}
                <small className="ml-0.5 text-[10px] sm:text-xs md:text-sm" data-id="element-133" data-mp="36e9hdztc6py7">
                  min
                </small>
              </span>
              <span className="text-gold/70 text-xl sm:text-2xl md:text-3xl" data-id="element-134" data-mp="14ll93c1u5cbk">
                :
              </span>
              <span className="whitespace-nowrap text-[30px] sm:text-4xl md:text-5xl" data-id="element-135" data-mp="19ky44k2v1pp8">
                {pad(timeLeft.seconds)}
                <small className="ml-0.5 text-[10px] sm:text-xs md:text-sm" data-id="element-136" data-mp="35m88aer881s0">
                  seg
                </small>
              </span>
            </div>
          </div>
        </div>

        {/* Big closing statement */}
        <div className="text-center mb-6 md:mb-10" data-id="element-137" data-mp="2vrgdfip13t0x">
          <h2 className="font-display font-black text-white text-3xl md:text-6xl leading-[1.05]" data-id="element-138" data-mp="2rmqhjtudeeg0">
            <span className="text-gold" data-id="element-139" data-mp="2mpqnkhasp259">TODO RESUELTO</span>
            <br data-id="element-140" data-mp="2hxyv2182wmch" />
            EN UN SOLO SISTEMA
          </h2>
        </div>

        {/* Single MegaPack CTA */}
        <div className="max-w-md mx-auto mb-6 md:mb-10" data-id="element-141" data-mp="2cym7tfdapd9d">
          <div className="relative bg-[#1C1040]/80 backdrop-blur border-2 border-gold rounded-2xl p-5 md:p-6 flex flex-col text-center featured-card-glow" data-id="element-142" data-mp="2cz5e1ytl2d7k">
            <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-gold text-[#1a0533] font-bold text-[10px] md:text-xs tracking-widest uppercase px-3 py-0.5 rounded-full shadow-lg whitespace-nowrap" data-id="element-143" data-mp="23yh01446wcuo">
              ⭐ OFERTA DE LANZAMIENTO
            </div>
            <div className="inline-block self-center bg-gold/15 border border-gold/40 text-gold font-bold text-[10px] md:text-xs tracking-widest uppercase mb-2 px-2.5 py-0.5 rounded-full" data-id="element-144" data-mp="ejesr6wtrfjx">
              🍱 MEGAPACK VIANDA RESUELTA
            </div>
            <p className="text-gold/90 font-semibold text-[12px] md:text-sm mb-3" data-id="element-145" data-mp="sfs4dzeogmqh">
              6 Tomos + 5 Bonos estratégicos
            </p>
            <div className="flex items-baseline justify-center gap-2 mb-3" data-id="element-146" data-mp="3ru5bo9txk24w">
              <span className="text-white/40 line-through text-[13px] md:text-base" data-id="element-147" data-mp="3vxtlkz61b9tb">
                USD 49.00
              </span>
              <span className="text-gold font-display font-black text-2xl md:text-4xl leading-none drop-shadow-[0_0_10px_rgba(245,166,35,0.45)]" data-id="element-148" data-mp="9hz5d876cwyd">
                USD 19
              </span>
            </div>
            <a href="https://checkout.prodikit.com/checkout" className="cta-btn inline-flex items-center justify-center text-white font-display font-extrabold text-[13px] md:text-sm uppercase tracking-wide px-4 py-3 rounded-full" data-id="element-149" data-mp="3d6snsegnhkbc">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </div>

        {/* Trust line — optimized */}
        <div className="text-center mb-5 md:mb-7 space-y-1.5" data-id="element-150" data-mp="p3agohoskfl2">
          <p className="text-white/60 text-[11px] md:text-xs italic" data-id="element-151" data-mp="p3tylyefz3z3">
            El cobro se realiza en la moneda de tu país.
          </p>
          <div className="flex flex-nowrap justify-center items-center gap-x-2 md:gap-x-3 text-white/85 text-[10px] md:text-sm whitespace-nowrap" data-id="element-152" data-mp="3skajp43u601y">
            <span className="flex items-center gap-1" data-id="element-153" data-mp="afz7unjzv9on">
              <Lock className="w-3 h-3 md:w-4 md:h-4 text-gold shrink-0" data-id="element-154" data-mp="5fkwown3jjme" /> Pago
              seguro
            </span>
            <span className="text-white/20" data-id="element-155" data-mp="1lsrwhphhni0h">|</span>
            <span className="flex items-center gap-1" data-id="element-156" data-mp="1lve3no0gvvi6">
              <Clock className="w-3 h-3 md:w-4 md:h-4 text-gold shrink-0" data-id="element-157" data-mp="1gtgfcfd7maid" />{' '}
              Acceso 5 min
            </span>
            <span className="text-white/20" data-id="element-158" data-mp="1pa79vnqqv0vp">|</span>
            <span className="flex items-center gap-1" data-id="element-159" data-mp="1tdlr2hqf5naq">
              <Shield className="w-3 h-3 md:w-4 md:h-4 text-gold shrink-0" data-id="element-160" data-mp="1tazjwj7fx9t1" />{' '}
              Garantía 7 días
            </span>
          </div>
          <div className="flex flex-nowrap justify-center items-center gap-x-2 md:gap-x-3 text-white/60 text-[10px] md:text-sm whitespace-nowrap" data-id="element-161" data-mp="1kbm6xgk3y33k">
            <span className="flex items-center gap-1" data-id="element-162" data-mp="282ruyj07c1oy">
              <CreditCard className="w-3 h-3 md:w-4 md:h-4 shrink-0" data-id="element-163" data-mp="2d1co5yh1dl3w" /> Tarjeta
            </span>
            <span className="text-white/20" data-id="element-164" data-mp="1ycylponj7ynv">|</span>
            <span className="flex items-center gap-1" data-id="element-165" data-mp="1ya2ok2jide0h">
              <Building className="w-3 h-3 md:w-4 md:h-4 shrink-0" data-id="element-166" data-mp="23a8ad233k6an" />{' '}
              Transferencia
            </span>
            <span className="text-white/20" data-id="element-167" data-mp="2qz9o94up89nb">|</span>
            <span className="flex items-center gap-1" data-id="element-168" data-mp="2vraxehwklk94">
              <Smartphone className="w-3 h-3 md:w-4 md:h-4 shrink-0" data-id="element-169" data-mp="2vsvr65b28z5x" />{' '}
              Plataformas locales
            </span>
          </div>
        </div>

        {/* Bottom trust icons strip — compact */}
        <div className="bg-white/5 backdrop-blur border border-white/10 rounded-xl p-3 md:p-4 mb-5 md:mb-7" data-id="element-170" data-mp="qwi7vrre0ciq">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-171" data-mp="lx5jh2kvaxe1">
            {trustBlocks.map((block, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-172" data-mp="1enxgg29rbq2f" data-mpi={i}>
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center text-gold mb-1.5" data-id="element-173" data-mp="19p2wgx01zvgq">
                  {cloneElement(block.icon, {
                className: 'w-4 h-4 md:w-5 md:h-5'
              })}
                </div>
                <p className="text-white text-[9px] md:text-[11px] font-bold tracking-wide leading-tight" data-id="element-174" data-mp="3qdq86i3pyl26">
                  {block.label}
                </p>
              </div>)}
          </div>
        </div>

        {/* Closing italic — highlighted */}
        <div className="relative max-w-2xl mx-auto" data-id="element-175" data-mp="20y5p2fx7l0ye">
          <div className="bg-gradient-to-r from-orange/15 via-orange/20 to-orange/15 border border-orange/50 rounded-xl px-4 py-3 md:px-6 md:py-4 shadow-[0_0_25px_rgba(245,166,35,0.25)]" data-id="element-176" data-mp="25v5xgxhj6fso">
            <p className="text-center text-orange font-semibold italic text-[13px] md:text-base leading-snug" data-id="element-177" data-mp="2enr45f7w0w15">
              <span className="block" data-id="element-178" data-mp="2jnlunhnr3jlo">Porque resolver viandas no debería</span>
              <span className="block" data-id="element-179" data-mp="2om6uhfz3c19l">
                costarte todos los domingos del año.
              </span>
              <span className="block font-bold not-italic whitespace-nowrap" data-id="element-180" data-mp="2tkqirn15pp54">
                En ningún país del mundo.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}